import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SalesOrderService } from "../sales-order.service";
import { Status, Severity } from "../../constants/constants";
import { DialogType, TemplateType, TypeIds, CustomAttributeFieldType } from "../constants/constants";
import { ICustomerRma, CustomerRmaProduct, BundleItems } from "../models/customer-return.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { validateFiles } from "src/app/modules/shared/upload-files";
import { MyDocumentsService } from "src/app/profile/my-documents";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { UtilityService } from "../utils/utility.service";
import data from "../../staticJSON/settings-column.json";
import { Subject, takeUntil } from "rxjs";
import { GelAllAccountRequestModel } from "src/app/accounts-v2/models/account-request.model";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "../services/account-flattening.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { UtilsService } from "../../purchases/utility/utils.service";
import { PurchasesService } from "../../purchases/purchases.service";
import { IPostingPeriodDetails } from "src/app/modules/shared/components/posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-return-add-edit",
    templateUrl: "./return-add-edit.component.html",
    styleUrls: ["./return-add-edit.component.scss"],
})
export class ReturnAddEditComponent implements OnInit, OnChanges {

    fieldTypes = CustomAttributeFieldType;

    //#region properties
    @Input() selectedReturn: any;
    @Input() displayReturnAdd;
    @Input() selectedChannel: any;
    @Input() type;
    @Input() dialogHeader;
    @Input() returnTemp;
    @Input() accountChannels;
    @Input() templates: any;
    @Input() rmaSections = [];
    @Input() allCustomAttributes: any;

    @Output() onCancelClicked = new EventEmitter();
    @Output() onRmaSaveComplete = new EventEmitter();

    returnForm: FormGroup;
    utilityServiceObj: UtilityService;
    FILE_SIZE = 5;
    MAX_SIZE = this.FILE_SIZE * 1024 * 1024; // 5MB
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"];
    files = [];
    showInvoiceNumber: boolean = false;
    selectedAccount;
    selectedLocation;
    allAccountsDD = [];
    searchBy = [];
    selectedSearch;
    allReasons = [];
    selectedReason;
    uploadedFiles: any = [];
    uploadedAttachments: any = [];
    selectedAttachments: any = [];
    allReturnTypes = [];
    selectedReturnType;
    selectedProductListTable = [];
    subtotal: number = 0;
    discount: number = 0;
    tax: number = 0;
    shipping: number = 0;
    orderTotal: number = 0;
    totalRefund: number = 0;
    isDisabledSaveBtn = false;
    displayList = false;
    displayTracking :boolean = false;
    invoiceItems = [];
    selectedProducts = [];
    customerReturnDetails;
    accountInfo: any;
    allInvoices: [];
    selectedInvoice: any;
    showAddProduct: boolean = false;
    disableInvoiceChange: boolean = false;
    rmaDetailsText: string;
    totalFileSize: any;
    newFileList: any;
    maxFilesizeErrorMessage: {
        severity: string;
        summary: string;
        detail: string;
    }[];
    newFileFolder: any;
    maxNoOfFilesErrorMessage: {
        severity: string;
        summary: string;
        detail: string;
    }[];
    displayNewUpload: boolean = false;
    serialNumberSuggestions: any[] | undefined;
    selectedSerialNumber: any;
    itemNumberSuggestions: any[] | undefined;
    selectedItemNumber: any;
    disableSerialNumberInput: boolean = false;
    disableItemNumberInput: boolean;
    hasSelectedProduct: boolean;
    showSaveButton: boolean = true;
    showUpdateButton: boolean = false;
    disabledUpdateBtn: boolean;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    footerData = {
        subtotal: this.subtotal,
        discount: this.discount,
        tax: this.tax,
        shipping: this.shipping,
        ordertotal: this.orderTotal,
        totalrefund: this.totalRefund
    }
    @ViewChild('fileUpload') fileUpload: any;

    //item table from template
    returnDetailsSection: any;
    disableSaveRmaButton: boolean = true;
    showProductChooseFooter: boolean = false;
    showShipping: any = false;
    rmaTemplate: any;
    footerColspan: any;
    invoiceItemsSection: any = [];
    allLocations = [];
    rmaLocations = [];
    statementMessege : string = "";
    closingDate = new Date();
    //#endregion

    //tracking
    @Input() trackingOptions = [];
    disabledSave: boolean = false;
    importForAllProducts: boolean = false;
    displayImport: boolean = false;
    systemTrackingData = [];
    unMatchedSerials = [];
    serialConfig;
    displayScanInfo = false;
    allChecked = false;
    nameLists = [];
    selectedProductForScan;
    selectedBundleForScan;
    trackingForm: FormGroup;
    listLength = 0;
    productSerialSettings;
    autoGenerateLists = [];
    totalTBRecord: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    pageSize: number = 100;
    pageNumber: number = 1;
    first: number = 0;
    refId: string = '';
    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;
    measurementUnits  = [];
    decimalPlacesMap: { [key: number]: number } = {};

    // currency
    baseCurrency: any;
    orgCurrency = [];
    currencyCode: string = '';
    exchangeRate: number = 0;

    // posting period
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    isAllowPostingPeriod: boolean = false;
    rmaDate = this.app._saveDateTimeWithZone(new Date());

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    constructor(private messageService: MessageService, public confirmationService: ConfirmationService,
        public appMainService: AppMainService, public documentService: MyDocumentsService, private datepipe: DatePipe,
        public app: AppMainComponent, public titleCasePipe: TitleCasePipe, private fb: FormBuilder,private purchaseService: PurchasesService,
        private salesOrderService: SalesOrderService, private utilityService: UtilityService, private accountServiceN: AccountServiceN,
        private accountFlatteningService: AccountFlatteningService,private importService: ImportserialService, private utilService: UtilsService,) { }

    ngOnInit() {
        this.utilityServiceObj = this.utilityService;
        this.rmaTemplate = this.templates?.filter((t) => t.typeId == TemplateType.CustomerRMA)[0];
        this.salesOrderService.getAllReturnTypes().subscribe((res) => {
            if (res) {
                this.allReturnTypes = res;
                this.returnForm?.controls['rmaTypeId']?.setValue(this.allReturnTypes?.find(type => type.isDefault));
            }
        });
        this.salesOrderService.getAllReturnReasons().subscribe((res) => {
            if (res) {
                this.allReasons = res;
            }
        });
        this.salesOrderService.getAllLionoCoreGroups().subscribe(group => {
            const searchBy = group.find(g => g.name == 'Search By');
            this.getSearchOptions(searchBy.id);
        })
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
        this.loadAllLocation();
        this.loadRMALocation();
        this.prepareTrackingForm();
        this.getFractionDigits();
        this.getBaseCurrency();
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.rmaTemplate = this.templates?.filter((t) => t.typeId == TemplateType.CustomerRMA)[0];
        if (this.rmaTemplate) {
            this.returnDetailsSection = this.rmaTemplate.labels_message;
            this.invoiceItemsSection = data.customerReturnInvoiceCols;
            this.footerColspan = this.rmaTemplate.labels_table?.filter(x => x.isChecked)!.length + 1;
        }
        this.disableInvoiceChange = this.selectedProducts.length > 0;
        if (changes?.type?.currentValue) {
            this.type = changes.type.currentValue;
            if (this.type == DialogType.CREATE) {
                this.uploadedFiles = [];
                this.initReturnForm();
            }
            else if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
                this.initializeCustomerReturn(this.selectedReturn.id);
            }
            this.initRmaCreate();
        }
        this.showInvoiceNumber = this.selectedSearch?.name != 'Invoice No.';
        this.disableSaveRmaButton = this.selectedProductListTable.length == 0;
    }

    initRmaCreate() {
        this.customFields = this.utilityService.getCustomerRMACustomAttributes(this.rmaTemplate, this.allCustomAttributes);
    }

    getSectionName(sectionCode) {
        const sectionName = this.rmaSections?.find(section => section.code == sectionCode)?.name;
        return sectionName;
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el.name === name)?.isRequired || false;
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe(resp=>{
            this.measurementUnits  = resp
          })
    }
    getDecimalPlacesCached(categoryId: number): number {
        if (!(categoryId in this.decimalPlacesMap)) {
          this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
      }
      getDecimalPlaces(categoryId: number): number {
          return this.measurementUnits?.some(unit => unit.id === categoryId && unit.name?.toLowerCase() === 'count') ? 0 : this.qtyFractionDigits ;
      }

    clearRMAForm() {
        this.selectedInvoice = null;
        this.selectedLocation = null;
        this.selectedProductListTable = [];
        this.selectedProducts = [];
        this.uploadedAttachments = [];
        this.uploadedFiles = [];
        this.selectedAttachments = [];
        this.disableInvoiceChange = false;
        this.showAddProduct = false;
        this.subtotal = 0;
        this.totalRefund = 0;
        this.discount = 0;
        this.tax = 0;
        this.shipping = 0;
        this.orderTotal = 0;
        this.fileUpload?.clear();
        this.updateTotals();
    }

    updateTotals() {
        this.footerData.subtotal = this.subtotal;
        this.footerData.discount = -this.discount;
        this.footerData.tax = -this.tax;
        this.footerData.shipping = -this.shipping;
        this.footerData.ordertotal = this.orderTotal;
        this.footerData.totalrefund = this.totalRefund;
    }

    initializeCustomerReturn(id) {
        this.initReturnForm();
        this.appMainService.isShowSpinner("loadCustomerReturn");
        this.salesOrderService
            .getCustomerReturnDetailsToConvert(id)
            .subscribe(async (res) => {
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.customerReturnDetails = res;
                await this.processReturnDetails(res);
            });
    }

    initReturnForm() {
        const iSettings = this.utilityService.getISettings();
        this.serialConfig = iSettings?.find((value) => value.code == "enableserial");
        this.returnForm = this.fb.group({
            id: [0],
            rmaTypeId: [null, [Validators.required]],
            channelId: [this.selectedChannel, [Validators.required]],
            accountId: [null, [Validators.required]],
            warehouseId: [null, [Validators.required]],
            rmaReasonId: [null, [Validators.required]],
            description: ['']
        });
        if(this.type == DialogType.VIEW){
          this.returnForm.disable()
        }
    }

    isClosingStatementDate(event : string) {
        this.statementMessege = event ;
    }

    setExistingCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: this.customerReturnDetails?.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]
                        ? this.customerReturnDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id
                        : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Customer RMA").id,
                    objectValue: this.customerReturnDetails.id,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" ? element.value : null,
                    statusId: 1,
                    status: null,
                    values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                    multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                    ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                    toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                    customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    setCustomAttributes(value) {
        const custom = [];
        if (value.length > 0) {
            value.forEach((element) => {
                const customEach = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.userId,
                    updatedBy: this.app.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    objectId: this.app.preLoadedObjects.find(
                        (obj) => obj.name == "Customer RMA"
                    ).id,
                    objectValue: 0,
                    customAttributeId: element.id,
                    customAttribute: this.modifyCustumAttributes(element),
                    value:
                        element.formControl?.name == "InputBox" ||
                            element.formControl?.name == "DatePicker"
                            ? element.value
                            : null,
                    statusId: 1,
                    status: null,
                    values:
                        element.formControl?.name == "DropDownList"
                            ? element.value
                            : element.formControl?.name == "RadioButton"
                                ? { name: element.value }
                                : null,
                    multipleValues:
                        element.formControl?.name == "MultipleDropDownList"
                            ? element.value
                            : element.formControl?.name == "CheckBox"
                                ? this.setCheckBoxValue(element.value)
                                : null,
                    ratingId:
                        element.formControl?.name == "Rating"
                            ? element.value
                            : 0,
                    toggle:
                        element.formControl?.name == "ToggleButton"
                            ? element.value
                            : false,
                    customeAttachement:
                        element.formControl?.name == "FileUpload" ||
                            element.formControl?.name == "Picture"
                            ? element.customUploadedFiles
                            : null,
                };
                custom.push(customEach);
            });
        }
        return custom;
    }

    modifyCustumAttributes(data) {
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }

    setCheckBoxValue(value) {
        const checkBox = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    async processReturnDetails(res) {
        this.returnForm.patchValue(res);
        this.exchangeRate = res?.exchangeRate;
        this.rmaTemplate = (res.configJSON ? JSON.parse(res.configJSON) : this.rmaTemplate);
        const filteredrmaTypeId = this.allReturnTypes?.find(type => type.id == res.rmaTypeId);
        this.returnForm.controls['rmaTypeId'].setValue(filteredrmaTypeId);
        const filteredChannelId = this.accountChannels?.find(channel => channel.id == res.channelId);
        this.returnForm.controls['channelId'].setValue(filteredChannelId);
        this.currentPostingPeriodInfo = {
            postingDate: res?.postingDate,
            postingMonth: res?.postingMonth,
            postingYear: res?.postingYear
        };
        
        let account = res.account;
        if(account){
            account["nameWithSequenceNumber"] = account?.sequenceNumber + "-"+ account?.businessName;
        }
        this.returnForm.controls['accountId'].setValue(account);
        const filteredReasonId = this.allReasons?.find(reason => reason.id == res.rmaReasonId);
        this.returnForm.controls['rmaReasonId'].setValue(filteredReasonId);
        for (let prd of res.customerRMAProducts) {
            prd.typeId = prd.product?.typeId;
            for (let bundle of prd.rmaBundleDetails) {
                bundle.typeId = bundle.product?.typeId;
                if (prd.product.typeId == 6) {
                    bundle.originalOrdQty = JSON.parse(JSON.stringify(bundle.qty));
                }
                if (bundle.childRMABundleDto?.length > 0) {
                    for (let kp of bundle.childRMABundleDto) {
                        kp.typeId = kp.product?.typeId;
                        kp.originalOrdQty = JSON.parse(JSON.stringify(kp.qty));
                    }
                    bundle.rmaBundleDetails = bundle.childRMABundleDto;
                }
            }
        }
        //this.selectedProductListTable = JSON.parse(JSON.stringify(res.customerRMAProducts));
        this.selectedProductListTable = this.convertProductPriceByExchangeRate(res.customerRMAProducts, res.exchangeRate);
        this.currencyCode = account?.currencyUnit?.symbol;
        this.uploadedFiles = [];
        res.rmaAttachments?.forEach(element => {
            this.uploadedFiles.push(element);
        });
        if (res.accountId > 0 && res.orderLocationId > 0) {
            this.showAddProduct = true;
        }
        if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
            const filteredWarehouseId = this.rmaLocations?.find(loc => loc.id == this.customerReturnDetails?.warehouseId);
            this.returnForm.controls['warehouseId'].setValue(filteredWarehouseId);
            const filteredLocationId = this.allLocations?.find(loc => loc.id == this.customerReturnDetails?.orderLocationId);
            this.selectedLocation = filteredLocationId;
        }
        this.selectedInvoice = { id: res.invoiceOrderId, number: res.invoice.number, name: res.invoice.number };
        this.calculateSubTotalAmount();
        this.calculateTotalRefundAmount();
        this.updateTotals();

        //populate saved custom field data
        Object.keys(this.customFields).forEach((key) => {
            const dataArr = this.customFields[key];
            if (dataArr && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const filteredCustom = this.customerReturnDetails?.customAttributeValues?.filter((c) => c.customAttributeId == element.id)[0];

                    if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                        element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                        element.value = filteredCustom.values.name;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el.name);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                });
            }
        });
    }

    deleteImage(imageId) {
        this.uploadedFiles?.forEach(element => {
            if (element.attachmentId == imageId) {
                const index = this.uploadedFiles.indexOf(element);
                this.uploadedFiles.splice(index, 1);
            }
        });
    }

    downloadFile(filePath) {
        window.open(filePath);
    }

    saveSelectedAttachments(event) {
        for (let file of event.files) {
            this.totalFileSize += file.size;
            this.selectedAttachments.push(file);
        }

        this.messageService.add({
            severity: "info",
            summary: "Attachemnt selected",
            detail: "Please upload before you save the return",
        });
    }

    removeSelectedAttachment(event) {
        const index = this.selectedAttachments.indexOf(event.file, 0);
        if (index > -1) {
            this.selectedAttachments.splice(index, 1);
        }
    }

    toggleInvoiceDropdown(event) {
        this.hasSelectedProduct = this.selectedProducts.length > 0;
        this.disableInvoiceChange = this.hasSelectedProduct;
        this.disableSerialNumberInput = this.hasSelectedProduct;
        this.disableItemNumberInput = this.hasSelectedProduct;
        this.showProductChooseFooter = this.selectedProducts.length > 0;
    }

    onChangeAccountChannel() {
        this.returnForm.controls['accountId'].setValue(null);
    }

    getSearchOptions(groupId) {
        this.salesOrderService.getAllSearchOptions(groupId).subscribe(res => {
            this.searchBy = res;
            this.selectedSearch = this.searchBy[0];
        })
    }

    onSearchByChange(event) {
        this.invoiceItems = [];
        this.selectedInvoice = null;
        this.selectedSerialNumber = null;
        this.selectedItemNumber = null;
        this.showInvoiceNumber = this.selectedSearch?.name != 'Invoice No.';
    }

    roundToTwoDecimal(data: number) {
        return Math.round((data + Number.EPSILON) * 100) / 100;
    }

    filterAccount(event) {
        let query = event.query;
        const channelId = this.returnForm.controls['channelId'].value?.id;
        query = event.query;
        this.appMainService.isShowSpinner('getAccountList');
        this.accountServiceN.getAccountsByNameWithHierarchy(channelId, query)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (response) => {
                if (response) {
                    this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                } else {
                    this.allAccountsDD = [];
                }
                this.appMainService.isHideSpinner('getAccountList');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getAccountList');
            },
            complete: () => {
                this.appMainService.isHideSpinner('getAccountList');
            }
        });
    }
    async accountSelected(event) {
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(
            event.id
        );
        if (this.selectedLocation && this.returnForm.controls['accountId'].value) {
            this.showAddProduct = true;
        }
        this.selectedProductListTable = [];
    }

    removeValue() {
        this.returnForm.controls['accountId']?.setValue(null)
        this.showAddProduct = false;
    }

    fetchInvoiceOrderItemsByInvoiceId(invoiceId: number) {
        const selectedAccountId = this.returnForm.controls['accountId'].value?.id;
        this.salesOrderService
            .getInvoiceOrderItemsByInvoiceId(selectedAccountId, invoiceId)
            .subscribe((res) => {
                this.PrepareInvoiceItems(res);
            });
    }

    fetchInvoiceOrderItemsBySerialNumber(serialNumber: string) {
        const selectedAccountId = this.returnForm.controls['accountId'].value?.id;
        const selectedWarehouseId = this.selectedLocation?.id;
        this.salesOrderService
            .getInvoiceOrderItemsBySerialNumber(selectedAccountId, selectedWarehouseId, serialNumber)
            .subscribe((res) => {
                this.PrepareInvoiceItems(res, 'serial');
            });
    }

    fetchInvoiceOrderItemsByItemNumber(itemNumber: string) {
        const selectedAccountId = this.returnForm.controls['accountId'].value?.id;
        const selectedWarehouseId = this.selectedLocation?.id;
        this.salesOrderService
            .getInvoiceOrderItemsByItemNumber(selectedAccountId, selectedWarehouseId, itemNumber)
            .subscribe((res) => {
                this.PrepareInvoiceItems(res, 'item');
            });
    }

    PrepareInvoiceItems(response: any, type?): void {
        this.currencyCode = response?.currencyCode;
        this.exchangeRate = response?.exchangeRate;
        if (response?.invoiceProducts) {
            this.invoiceItems = this.convertProductPriceByExchangeRate(response.invoiceProducts, response.exchangeRate);
            if (type) {
                this.selectedInvoice = this.allInvoices?.find((inv: any) => inv.id == response.invoiceProducts[0]?.invoiceId);
            }
            this.subtotal = response.subTotal;
        }
    }

    convertProductPriceByExchangeRate(products: any[], exchangeRate: number = 1) {
        const updatePrices = (item: any) => {
            const updatedItem = {
                ...item,
                amount: item.amount * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                rate: item.rate * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                shippingPerPrice: item.shippingPerPrice * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                originalPrice: item.originalPrice * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                returnAmount: item.returnAmount * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                taxPerPrice: item.taxPerPrice * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
                discountPerPrice: item.discountPerPrice * (exchangeRate ? exchangeRate : this.baseCurrency?.exchangeRate),
            };

            if (updatedItem?.invoiceBundleDto && updatedItem?.invoiceBundleDto?.length > 0) {
                updatedItem.invoiceBundleDto = updatedItem.invoiceBundleDto.map((bundleItem) => updatePrices(bundleItem));
            }
            return updatedItem;
        };
        return products.map((item) => updatePrices(item));
    }

    onChangeInvoice(event) {
        this.invoiceItems = [];
        this.selectedProducts = [];
        this.selectedInvoice = event.value;
        this.fetchInvoiceOrderItemsByInvoiceId(this.selectedInvoice?.id);
    }

    onSerialNumberInput(event) {
        const serialNumber = event.query;
        const selectedAccountId = this.returnForm.controls['accountId'].value?.id;
        const selectedLocationId = this.selectedLocation?.id;
        this.salesOrderService.getSerialNumbers(selectedAccountId, selectedLocationId, serialNumber).subscribe((res: any) => {
            if (res) {
                this.serialNumberSuggestions = res;
            }
        });
    }

    onSerialNumberInvoiceSelect(value) {
        this.selectedSerialNumber = value;
        this.fetchInvoiceOrderItemsBySerialNumber(value);
    }

    onItemNumberInput(event) {
        const itemNumber = event.query;
        const selectedAccountId = this.returnForm.controls['accountId'].value?.id;
        const selectedLocationId = this.selectedLocation?.id;
        this.salesOrderService.getItemNumbers(selectedAccountId, selectedLocationId, itemNumber).subscribe((res) => {
            if (res) {
                this.itemNumberSuggestions = res;
            }
        });
    }

    onItemNumberInvoiceSelect(value) {
        this.selectedItemNumber = value;
        this.fetchInvoiceOrderItemsByItemNumber(value);
    }

    onDialogClose() {
        this.displayReturnAdd = false;
        this.clearRMAForm();
        this.returnForm.reset();
        this.onCancelClicked.emit(false);
    }

    calReturnAmt(product, bundle?) {
        //calculate return qty for Kit
        if (product.typeId == 6) {
            for (let kItems of product.rmaBundleDetails) {
                kItems.returnQty = (kItems.originalOrdQty * product.returnQty) / (product.qty);
                if (kItems.rmaBundleDetails?.length > 0) {
                    for (let kp of kItems.rmaBundleDetails) {
                        kp.returnQty = (kp.originalOrdQty * product.returnQty) / (product.qty);
                    }
                }
            }
        }
        product.returnAmount = this.roundToTwoDecimal(
            product.returnQty * product.rate
        );
        if (bundle) {
            this.calculateBundleReturnAmt(bundle);
        } else {
            this.calculateSubTotalAmount();
            this.calculateTotalRefundAmount();
            this.updateTotals();
        }
    }

    calculateSubTotalAmount() {
        this.subtotal = 0;
        for (let prd of this.selectedProductListTable) {
            this.subtotal += this.roundToTwoDecimal(Number(prd.returnAmount))
        }
        this.subtotal = this.roundToTwoDecimal(this.subtotal);
    }

    calculateTotalRefundAmount() {
        this.totalRefund = 0;
        this.selectedProductListTable.forEach(
            (e) => (this.totalRefund += this.roundToTwoDecimal(Number(e.returnAmount)))
        );
        this.totalRefund = this.roundToTwoDecimal(this.totalRefund);
        this.footerData['totalrefund'] = this.totalRefund;
    }

    showProductList(accountId, locationId) {
        this.selectedSearch = this.searchBy[0];
        //this.selectedInvoice=null;
        this.selectedSerialNumber = null;
        this.selectedItemNumber = null;
        if (accountId) {
            this.invoiceItems = [];
            this.selectedProducts = JSON.parse(JSON.stringify(this.selectedProductListTable));
            this.hasSelectedProduct = this.selectedProducts.length > 0;
            this.disableInvoiceChange = this.hasSelectedProduct;
            this.disableSerialNumberInput = this.hasSelectedProduct;
            this.disableItemNumberInput = this.hasSelectedProduct;
            this.showProductChooseFooter = this.selectedProducts.length > 0;
            this.loadInvoices(accountId, locationId);
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please select proper account information",
            });
        }
    }

    loadInvoices(accountId, locationId) {
        this.salesOrderService.getAllInvoicesByAccountId(accountId, locationId).subscribe((res: any) => {
            if (res) {
                this.allInvoices = res.map((x) => {
                    return { ...x, name: x.number };
                });
            }
            if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
                this.selectedInvoice = this.allInvoices?.find((inv: any) => inv.id == this.customerReturnDetails?.invoiceOrderId)
            }
            if (this.selectedInvoice) {
                this.fetchInvoiceOrderItemsByInvoiceId(this.selectedInvoice?.id);
            }
            this.displayList = true;
        });
    }

    locationChanged(event) {
        this.selectedInvoice = null;
        if (this.selectedLocation && this.returnForm.controls['accountId'].value) {
            this.showAddProduct = true;
        } else {
            this.showAddProduct = false;
        }
        this.selectedProductListTable = [];
        this.loadInvoices(this.returnForm.controls['accountId'].value?.id, this.selectedLocation?.id);

    }

    removeProduct(index) {
        const stop = this.selectedProductListTable.length - 1;
        while (index < stop) {
            this.selectedProductListTable[index] =
                this.selectedProductListTable[++index];
        }
        this.selectedProductListTable.pop();
        this.selectedProducts = JSON.parse(
            JSON.stringify(this.selectedProductListTable)
        );
        this.calculateSubTotalAmount();
        this.calculateTotalRefundAmount();
        this.updateTotals();
        this.toggleInvoiceDropdown(null);
    }

    removeBundleProduct(index, bundle) {
        bundle.rmaBundleDetails?.splice(index, 1);
        if (bundle.rmaBundleDetails?.length == 0) {
            const filtered = this.selectedProductListTable?.find(prd => prd.id == bundle.id);
            const ind = this.selectedProductListTable.indexOf(filtered);
            this.selectedProductListTable.splice(ind, 1);
        }
        this.calculateBundleReturnAmt(bundle);
    }

    calculateBundleReturnAmt(bundle) {
        bundle.returnAmount = 0;
        for (let bItems of bundle.rmaBundleDetails) {
            bundle.returnAmount += this.roundToTwoDecimal(Number(bItems.returnAmount));
        }
        this.calculateSubTotalAmount();
        this.calculateTotalRefundAmount();
        this.updateTotals();
    }

    saveList() {
        for (let prd of this.selectedProducts) {
            for (let kp of prd?.invoiceBundleDto) {
                kp.rmaBundleDetails = kp?.childInvoiceBundleDetailDto ?? [];
            }
            prd.rmaBundleDetails = prd?.invoiceBundleDto ?? [];
            if (prd.typeId == TypeIds.KitTypeId) {
                prd.binId = prd.bins[0]?.id;
                for (let kItems of prd?.rmaBundleDetails) {
                    kItems.originalOrdQty = JSON.parse(JSON.stringify(kItems.qty));
                    if (kItems.rmaBundleDetails?.length > 0) {
                        for (let kp of kItems?.rmaBundleDetails) {
                            kp.originalOrdQty = JSON.parse(JSON.stringify(kp.qty));
                        }
                    }
                }
            }
        }
        this.selectedProductListTable = JSON.parse(JSON.stringify(this.selectedProducts));
        this.calculateSubTotalAmount();
        this.calculateTotalRefundAmount();
        this.updateTotals();
        this.displayList = false;
        this.toggleInvoiceDropdown(null);
        this.disableSaveRmaButton = this.selectedProductListTable.length == 0;
    }

    validateRMA(productList) {
        for (let prd of productList) {
            if (!prd.returnQty || Number(prd.returnQty) == 0) {
                return false;
            } else {
                return true
            }
        }
    }

    save(value) {
        if (this.selectedAttachments?.length > this.uploadedAttachments?.length) {
            this.confirmationService.confirm({
                message: "You have not uploaded all the selected attachments. Do you want to continue?",
                header: "RMA Create Confirmation",
                icon: "pi pi-info-circle",
                accept: () => {
                    this.createRMA(value);
                },
                reject: () => { },
            });
        } else {
            this.createRMA(value);
        }
    }

    createRMA(value) {
        const isValid = this.validateRMA(this.selectedProductListTable);
        const customAttributeList = this.utilityService.getCustomAttributesForAddEdit(this.customFields);
        if (!isValid) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please create RMA with return qty greater than 0.",
            });
            return
        }
        if (this.utilityService.checkvalidation(this.customFields) && this.type == DialogType.CREATE) {
            this.addNewCustomerReturn(value, customAttributeList);
        } else if (this.utilityService.checkvalidation(this.customFields) && this.type == DialogType.EDIT) {
            this.updateCustomerReturn(value, customAttributeList);
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill up all required fields",
            });
        }
    }

    addNewCustomerReturn(value, customAttributes) {
        this.isDisabledSaveBtn = true;
        const rmaData = this.getCustomerReturnCreateModel(value, customAttributes);
        this.appMainService.isShowSpinner("loadCustomerReturn");
        this.salesOrderService.createCustomerReturn(rmaData, this.isBaseCurrency()).then(() => {
            this.appMainService.isHideSpinner("loadCustomerReturn");
            this.isDisabledSaveBtn = false;
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Customer return saved successfully",
            });
            this.onRmaSaveComplete.emit(false);
        })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving customer return",
                });
            });
    }

    updateCustomerReturn(value, customAttributeList) {
        this.isDisabledSaveBtn = true;
        let rmaData = this.getCustomerReturnCreateModel(value, customAttributeList);
        this.appMainService.isShowSpinner("loadCustomerReturn");
        this.salesOrderService.updateCustomerReturn(rmaData, this.isBaseCurrency()).then(() => {
            this.appMainService.isHideSpinner("loadCustomerReturn");
            this.isDisabledSaveBtn = false;
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Customer return saved successfully",
            });
            this.selectedInvoice = null;
            this.selectedLocation = null;
            this.selectedProductListTable = null;
            this.uploadedAttachments = [];
            this.selectedAttachments = [];
            this.subtotal = 0;
            this.totalRefund = 0;
            this.rmaDetailsText = "";
            this.disableInvoiceChange = false;
            this.onRmaSaveComplete.emit(false);
        })
            .catch(() => {
                this.isDisabledSaveBtn = false;
                this.appMainService.isHideSpinner("loadCustomerReturn");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving customer return",
                });
            });
    }

    getCustomerReturnCreateModel(value, customAttributes) {
        let customerRmaObj: ICustomerRma = {
            id: (this.type == DialogType.EDIT ? this.customerReturnDetails?.id : 0),
            createdSource:
                this.type == DialogType.EDIT
                    ? this.customerReturnDetails.createdSource
                    : this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy:
                this.type == DialogType.EDIT
                    ? this.customerReturnDetails.createdBy
                    : this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate:
                this.type == DialogType.EDIT
                    ? this.customerReturnDetails.createdDate
                    : this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            number:
                this.type == DialogType.EDIT
                    ? this.customerReturnDetails.number
                    : "",
            description: value.description,
            organizationId: this.app.companyId,
            channelId: value.channelId?.id,
            accountId: value.accountId?.id,
            warehouseId: value.warehouseId?.id,
            orderLocationId: this.selectedLocation?.id,
            userId:
                this.type == DialogType.EDIT
                    ? this.customerReturnDetails.createdBy
                    : this.app.user.userId,
            totalAmount: this.subtotal,
            netAmount: this.subtotal,
            refundAmount: this.totalRefund,
            exchangeRate : this.exchangeRate ?? 0,
            currencyUnitId: 0,
            statusId: 1,
            rmaStatusId: (this.type == DialogType.CREATE ? 1 : this.customerReturnDetails?.rmaStatusId),
            rmaStageId: (this.type == DialogType.CREATE ? 1 : this.customerReturnDetails?.rmaStageId),
            rmaTypeId: value.rmaTypeId?.id,
            rmaReasonId: value.rmaReasonId?.id,
            referenceNumber: "",
            invoiceOrderId: this.selectedInvoice?.id,
            rmaDate: this.app._saveDateTimeWithZone(new Date()),
            configJSON: JSON.stringify(this.rmaTemplate),
            customerRMANotes: [],
            customerRMAProducts: [],
            customAttributeValues: (this.type == DialogType.CREATE ? this.setCustomAttributes(customAttributes) : this.setExistingCustomAttributes(customAttributes)),
            rmaAttachments: (this.type == DialogType.CREATE ? this.uploadedAttachments : this.setExistingFiles(this.uploadedAttachments)),
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : (this.type == DialogType.EDIT ? this.customerReturnDetails?.postingDate : this.app._saveDateTimeWithZone(new Date())),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (this.type == DialogType.EDIT ? this.customerReturnDetails?.postingMonth : new Date().getMonth() + 1),
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (this.type == DialogType.EDIT ? this.customerReturnDetails?.postingYear : new Date().getFullYear())
        };
        customerRmaObj.customerRMAProducts = this.getCustomerRmaProducts(customerRmaObj);
        return customerRmaObj;
    }



    setExistingFiles(newFiles) {
        let files = newFiles;
        for (let file of this.uploadedFiles) {
            const fileObj = {
                attachmentId: file.attachmentId,
                attachmentName: file.attachmentName,
                extension: file.extension,
                uploadedBy: file.uploadedBy,
                uploadedDate: file.createdDate
            }
            files.push(fileObj);
        }
        return files;
    }

    setBundleProducts(bundleDetails) {
        const data = [];
        bundleDetails?.forEach((product) => {
            const bundleProduct: BundleItems = {
                id: (this.type == DialogType.EDIT ?
                    (this.customerReturnDetails?.customerRMAProducts?.filter(pr => pr.productId == product.productId)[0] ? this.customerReturnDetails?.customerRMAProducts?.filter(pr => pr.productId == product.productId)[0].rmaBundleDetails?.filter(b => b.subProductId == product.subProductId)[0] ? this.customerReturnDetails.customerRMAProducts.filter(pr => pr.productId == product.productId)[0].rmaBundleDetails?.filter(b => b.subProductId == product.subProductId)[0].id : 0 : 0)
                    : 0),
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
                customerRMAId: (this.type == DialogType.EDIT ? this.customerReturnDetails?.id : 0),
                rmaProductId: (this.type == DialogType.EDIT ? this.customerReturnDetails?.customerRMAProducts?.filter(prd => prd.productId == product.productId).map(prdObj => prdObj.id)[0] : 0),
                subProductId: product.subProductId,
                parentProductId: 0,
                parentBundleId: 0,
                availableQty: 0,
                totalQty: 0,
                quantity: product.originalOrdQty,
                actualPrice: 0,
                discountId: 0,
                statusId: 1,
                description: product.description,
                productId: product.productId,
                warrantyPeriod: this.app._saveDateTimeWithZone(new Date()),
                warrantyTypeId: product.warrantyTypeId,
                warranty: product.warranty,
                shippedQuantity: product.qty,
                binId: product.binId,
                returnQuantity: product.returnQty,
                approvedQuantity: 0,
                productUOMId: product.productUOMId,
                pricePerProduct: product.rate,
                totalAmount: product.returnAmount,
                invoiceId: product.invoiceId,
                rmaBundleProductSerialDetail: product.rmaBundleProductSerialDetail
            };
            data.push(bundleProduct);
            /*kit under kit items*/
            if (product.rmaBundleDetails?.length > 0) {
                for (let kp of product.rmaBundleDetails) {
                    const bundleProduct: BundleItems = {
                        id: (this.type == DialogType.EDIT ? (kp.id ? kp.id : 0) : 0),
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.userId,
                        updatedBy: this.app.userId,
                        createdDate: new Date().toISOString(),
                        updatedDate: new Date().toISOString(),
                        customerRMAId: (this.type == DialogType.EDIT ? this.customerReturnDetails?.id : 0),
                        rmaProductId: (this.type == DialogType.EDIT ? this.customerReturnDetails?.customerRMAProducts?.filter(prd => prd.productId == product.productId).map(prdObj => prdObj.id)[0] : 0),
                        subProductId: kp.subProductId,
                        parentProductId: product.subProductId,
                        parentBundleId: (this.type == DialogType.EDIT ? kp.parentBundleId : 0),
                        availableQty: 0,
                        totalQty: 0,
                        quantity: kp.originalOrdQty,
                        actualPrice: 0,
                        discountId: 0,
                        statusId: 1,
                        description: kp.description,
                        productId: product.productId,
                        warrantyPeriod: this.app._saveDateTimeWithZone(new Date()),
                        warrantyTypeId: kp.warrantyTypeId,
                        warranty: kp.warranty,
                        shippedQuantity: kp.qty,
                        binId: kp.binId,
                        returnQuantity: kp.returnQty,
                        approvedQuantity: 0,
                        productUOMId: kp.productUOMId,
                        pricePerProduct: kp.rate,
                        totalAmount: kp.returnAmount,
                        invoiceId: kp.invoiceId,
                        rmaBundleProductSerialDetail: kp.rmaBundleProductSerialDetail
                    };
                    data.push(bundleProduct);
                }
            }

        });
        return data;
    }

    getCustomerRmaProducts(customerRmaObj: ICustomerRma): CustomerRmaProduct[] {
        let selectedProductsForRma: CustomerRmaProduct[] = [];
        this.selectedProductListTable.forEach((product) => {
            const rmaProduct = new CustomerRmaProduct(this.app, this.type, this.customerReturnDetails);
            rmaProduct.id = (this.type == DialogType.EDIT ? this.customerReturnDetails?.customerRMAProducts?.filter(prd => prd.productId == product.productId).map(prdObj => prdObj.id)[0] : 0);
            rmaProduct.customerRMAId = customerRmaObj.id;
            rmaProduct.description = product.description;
            rmaProduct.productId = product.productId;
            rmaProduct.warrantyPeriod = this.app._saveDateTimeWithZone(new Date());
            rmaProduct.warrantyTypeId = product.warrantyTypeId;
            rmaProduct.warranty = product.warranty;
            rmaProduct.shippedQuantity = product.qty;
            rmaProduct.binId = product.binId;
            rmaProduct.returnQuantity = product.returnQty;
            rmaProduct.approvedQuantity = 0;
            rmaProduct.productUOMId = product.productUOMId;
            rmaProduct.pricePerProduct = product.rate;
            rmaProduct.totalAmount = product.returnAmount;
            rmaProduct.invoiceId = product.invoiceId;
            rmaProduct.rmaProductSerialDetails = product.rmaProductSerialDetails;
            rmaProduct.rMABundleDetails = this.setBundleProducts(product.rmaBundleDetails);
            selectedProductsForRma.push(rmaProduct);
        });
        return selectedProductsForRma;
    }

    saveAttachments(files: File[]) {
        this.selectedAttachments = files;
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(
                    file,
                    this.FILE_SIZE,
                    this.allowedExtensions
                );
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    this.newFileList.push(file);
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
        if (this.newFileList.length > 3) {
            this.maxNoOfFilesErrorMessage = [
                {
                    severity: "error",
                    summary: "Error",
                    detail: "No. of files should be three",
                },
            ];
        } else {
            this.maxNoOfFilesErrorMessage = []; // Remove the error message
        }
    }

    createUpdateFolderFiles() {
        if (this.totalFileSize > this.MAX_SIZE) {
            this.messageService.add({
                severity: Severity.Warn,
                summary: "Maximum Upload Size Limit Exceeded",
                detail: "Maximum upload size is 5MB!",
            });
            return;
        }

        const formData = this.setFormData(this.selectedAttachments);
        formData.append("ModuleNameWithDisplayOrder", "CustomerRMA-1");

        this.appMainService.isShowSpinner("uplaodFile");
        this.documentService.uploadFilesByOrganization(formData).subscribe({
            next: (data) => {
                this.uploadedAttachments.push(...data);
                this.displayNewUpload = false;
                this.appMainService.isHideSpinner("uplaodFile");
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titleCasePipe.transform(Severity.Success),
                    detail: "Saved Successfully ...",
                });
            },
            error: (error) => {
                this.appMainService.isHideSpinner("uplaodFile");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titleCasePipe.transform(Severity.Error),
                    detail: "Error occurred ...",
                });
            },
        });
    }

    setFormData(files): any {
        const formData = new FormData();
        for (let file of files) {
            formData.append("Files", file);
        }
        return formData;
    }

    onUpload(event) {
        this.createUpdateFolderFiles();
    }

    uploadAttachments(event) {
        this.createUpdateFolderFiles();
    }

    loadAllLocation() {
        this.allLocations = [];
        this.appMainService.isShowSpinner('loadAllLocation');
        this.salesOrderService.getAllLocations("0", "0", "")
            .subscribe({
                next: res => {
                    this.appMainService.isHideSpinner('loadAllLocation');
                    if (res && res.length > 0) {
                        this.allLocations = res?.map(l => ({
                            ...l,
                            name: l.locationId + " - " + l.name,
                            contactName: l.contactPersonName,
                            qty: l.qtyInStock
                        }));
                        if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
                            const filteredWarehouseId = this.allLocations?.find(loc => loc.id == this.customerReturnDetails?.orderLocationId);
                            this.selectedLocation = (filteredWarehouseId);
                        } else {
                            const filteredWarehouseId = this.allLocations?.find(loc => loc.isDefault);
                            this.selectedLocation = (filteredWarehouseId);
                        }
                    }
                },
                error: () => {
                    this.appMainService.isHideSpinner('loadAllLocation');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
                }
            });
    }

    loadRMALocation() {
        this.rmaLocations = [];
        this.appMainService.isShowSpinner('loadAllLocation');
        this.salesOrderService.getRMALocations().subscribe({
            next: res => {
                this.appMainService.isHideSpinner('loadAllLocation');
                if (res && res.length > 0) {
                    this.rmaLocations = res?.map(l => ({
                        ...l,
                        name: l.locationId + " - " + l.name,
                    }));
                    if (this.type == DialogType.VIEW || this.type == DialogType.EDIT) {
                        const filteredWarehouseId = this.rmaLocations?.find(loc => loc.id == this.customerReturnDetails?.warehouseId);
                        this.returnForm.controls['warehouseId'].setValue(filteredWarehouseId);
                    } else {
                        const filteredWarehouseId = this.rmaLocations?.find(loc => loc.isRMAWarehouse);
                        this.returnForm.controls['warehouseId'].setValue(filteredWarehouseId);
                    }
                }
            },
            error: () => {
                this.appMainService.isHideSpinner('loadAllLocation');
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
            }
        });
    }

    //tracking
    // checkSerialNoInSystem(productId, warehouseId, orderId) {
    //     this.salesOrderService.checkSerialNoInSystem(orderId, warehouseId, productId).subscribe((data) => {
    //         this.systemTrackingData = data;
    //     });
    // }
      //tracking
  checkSerialNoInSystem(productId, warehouseId,invoiceId) {
    this.salesOrderService.checkSerialNoInCustomerReturnSystem(warehouseId, productId,invoiceId , this.customerReturnDetails?.id).subscribe((data) => {
      this.systemTrackingData = data;
      this.autoGenerateLists = this.autoGenerateLists?.slice(0, 100)?.map(name => {
        const isPresent = this.systemTrackingData?.some(item => item?.serialNo == name?.serialNo);
        return {
          ...name,
          systemPresent: isPresent
        };
      });
      this.nameLists = this.autoGenerateLists
    });
  }
    openScanInfo(product) {
        this.allChecked = false;
        this.importForAllProducts = false;
        this.nameLists = [];
        this.unMatchedSerials = [];
        this.autoGenerateLists = [];
        this.refId = '';
        this.selectedProductForScan = JSON.parse(JSON.stringify(product));
        this.productSerialSettings = product.trackingSetting ? JSON.parse(product?.trackingSetting) : null;
        this.selectedBundleForScan = null;
        this.prepareTrackingForm();
        this.displayScanInfo = true;
        const data = product.rmaProductSerialDetails?.length > 0 ? product?.rmaProductSerialDetails[0] : null;
        this.trackingForm.patchValue({
          lotNo: data?.lotNumber ? data.lotNumber : "",
          revisionNo: data?.revisionNumber ? data.revisionNumber : "",
          expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });
        const arr = [];
        if (product.rmaProductSerialDetails?.length > 0) {
          product.rmaProductSerialDetails?.forEach((element) => {
            const obj = {
              id: element.id,
              serialNo: element.barcode,
              serialNo2: element.serialNumber2,
              serialNo3: element.serialNumber3,
              serialNo4: element.serialNumber4,
              serialNo5: element.serialNumber5,
              serialNo6: element.serialNumber6,
              serialNo7: element.serialNumber7,
              serialNo8: element.serialNumber8,
              serialNo9: element.serialNumber9,
              serialNo10: element.serialNumber10,
              serialNo11: element.serialNumber11,
              serialNo12: element.serialNumber12,
              serialNo13: element.serialNumber13,
              serialNo14: element.serialNumber14,
              serialNo15: element.serialNumber15,
              serialNo16: element.serialNumber16,
              serialNo17: element.serialNumber17,
              lotNo: element.lotNumber,
              revisionNo: element.revisionNumber,
              expiration: element.expirationDate,
              systemPresent: element.systemPresent,
              referenceId: this.refId 
            };
            arr.push(obj);
          });
        }
        this.autoGenerateLists = arr;
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.checkSerialNoInSystem(this.selectedProductForScan?.productId, this.returnForm?.controls?.["warehouseId"].value?.id,this.selectedProductForScan?.invoiceId);
        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
          this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator([
            'lotNo', 'revisionNo', 'expiration',
            'serialNo', 'serialNo2', 'serialNo3', 'serialNo4', 'serialNo5',
            'serialNo6', 'serialNo7', 'serialNo8', 'serialNo9', 'serialNo10',
            'serialNo11', 'serialNo12', 'serialNo13', 'serialNo14', 'serialNo15',
            'serialNo16', 'serialNo17'
          ]));
          this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
      }

    openScanInfoForBundle(bundle, product) {
        this.allChecked = false;
        this.prepareTrackingForm();
        this.importForAllProducts = false;
        this.refId = '' ;
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.selectedProductForScan = JSON.parse(JSON.stringify(product));
        this.selectedBundleForScan = JSON.parse(JSON.stringify(bundle));
        this.productSerialSettings = product.trackingSetting ? JSON.parse(product.trackingSetting) : null;;
        this.displayScanInfo = true;
        const data = product.rmaBundleProductSerialDetail?.length > 0 ? product.rmaBundleProductSerialDetail[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : null,
        });

        const arr = [];
        if (product.rmaBundleProductSerialDetail?.length > 0) {
            product.rmaBundleProductSerialDetail.forEach((element) => {
                const obj = {
                    id: element.id,
                    serialNo: element.barcode,
                    serialNo2: element.serialNumber2,
                    serialNo3: element.serialNumber3,
                    serialNo4: element.serialNumber4,
                    serialNo5: element.serialNumber5,
                    serialNo6: element.serialNumber6,
                    serialNo7: element.serialNumber7,
                    serialNo8: element.serialNumber8,
                    serialNo9: element.serialNumber9,
                    serialNo10: element.serialNumber10,
                    serialNo11: element.serialNumber11,
                    serialNo12: element.serialNumber12,
                    serialNo13: element.serialNumber13,
                    serialNo14: element.serialNumber14,
                    serialNo15: element.serialNumber15,
                    serialNo16: element.serialNumber16,
                    serialNo17: element.serialNumber17,
                    lotNo: element.lotNumber,
                    revisionNo: element.revisionNumber,
                    expiration: element.expirationDate,
                    systemPresent: element.systemPresent,
                    referenceId: this.refId
                };
                arr.push(obj);
            });
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        // this.checkSerialNoInSystem(this.selectedProductForScan?.id,this.selectedLocation?.id, 0);
        this.checkSerialNoInSystem(this.selectedProductForScan?.productId, this.returnForm?.controls?.["warehouseId"].value?.id,this.selectedProductForScan?.invoiceId);

        // Apply the custom validator after initializing the form
        if (!this.utilService.hasRequiredValidator(this.trackingForm)) {
            this.trackingForm.setValidators(this.utilService.atLeastOneFieldValidator(["lotNo", "revisionNo", "expiration", "serialNo", "serialNo2", "serialNo3", "serialNo4", "serialNo5", "serialNo6", "serialNo7", "serialNo8", "serialNo9", "serialNo10", "serialNo11", "serialNo12", "serialNo13", "serialNo14", "serialNo15", "serialNo16", "serialNo17"]));
            this.trackingForm.updateValueAndValidity(); // Ensure validation is applied
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.returnQty - this.listLength)
    }
  applyDynamicValidation() {
    // Reset validation first
    this.trackingForm.controls['lotNo'].clearValidators();
    this.trackingForm.controls['revisionNo'].clearValidators();
    if (this.productSerialSettings) {
      const { lotChecked, revisionChecked } = this.productSerialSettings;

      if (lotChecked && revisionChecked) {
        // Both enabled → Apply validation to LotNo only
        this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      } else if (revisionChecked) {
        // Only RevisionNo enabled → Apply validation to RevisionNo
        this.trackingForm.controls['revisionNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      } else if (lotChecked) {
        // Only LotNo enabled → Apply validation to LotNo
        this.trackingForm.controls['lotNo'].setValidators([Validators.required, Validators.pattern(/^(?!\s*$).+/)]);
      }
      // Ensure form controls update their validation state
      this.trackingForm.controls['lotNo'].updateValueAndValidity();
      this.trackingForm.controls['revisionNo'].updateValueAndValidity();
    }

    // Update the form controls
    this.trackingForm.controls['lotNo'].updateValueAndValidity();
    this.trackingForm.controls['revisionNo'].updateValueAndValidity();
  }
    /**tracking SerialNo**/
    prepareTrackingForm() {
        const qty = this.selectedProductForScan?.returnQty;
        this.trackingForm = this.fb.group({
            qty: [qty - this.listLength, [Validators.required]],
            lotNo: [""],
            revisionNo: [""],
            expiration: [""],
            serialNo: [""],
            serialNo2: [""],
            serialNo3: [""],
            serialNo4: [""],
            serialNo5: [""],
            serialNo6: [""],
            serialNo7: [""],
            serialNo8: [""],
            serialNo9: [""],
            serialNo10: [""],
            serialNo11: [""],
            serialNo12: [""],
            serialNo13: [""],
            serialNo14: [""],
            serialNo15: [""],
            serialNo16: [""],
            serialNo17: [""],
            packageBarcode: [""]
        });
        /**set validation for Tracking form**/
        for (let opt of this.trackingOptions) {
            if (opt.enabled && (this.productSerialSettings ? this.productSerialSettings[`${opt.code}`] : true)) {
                if (opt.field !== 'serialNo' && opt.isRequired) {
                    this.trackingForm?.get(`${opt.field}`).setValidators(Validators.required);
                } else if (opt.field === 'serialNo' && opt.isRequired) {
                    if (this.utilityService.displayName('serializedChecked', this.trackingOptions, 'control') == 'InputBox') {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9-]*$/)]);
                    } else {
                        this.trackingForm?.get(`${opt.field}`).setValidators([Validators.required]);
                    }
                } else {
                    this.trackingForm?.get(`${opt.field}`).clearValidators();
                }
                this.trackingForm?.get(`${opt.field}`).updateValueAndValidity();
            }
        }
    }

    countNameList(value) {
        if (this.trackingForm.valid && this.listLength < this.selectedProductForScan?.returnQty) {
          if (value.serialNo) {
            const duplicate = this.autoGenerateLists?.filter(sr => sr.serialNo == value.serialNo);
            if (duplicate?.length > 0) {
                this.messageService.add({
                    severity: 'error', summary: 'Error',
                    detail: "Serial No you tried to enter is already present in below list.",
                });
            } else {
                const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == value.serialNo);
                if (present) {
                    value.systemPresent = true;
                    value.checked = false;
                    this.autoGenerateLists.push(value);
                    this.nameLists = this.autoGenerateLists.slice(0, 100);
                    this.listLength = this.listLength + 1;
                    this.totalTBRecord = this.listLength;
                    this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
                } else {
                    this.checkSerialsForSystem(this.trackingForm.controls["serialNo"].value, this.selectedProductForScan?.id,
                        this.returnForm.controls['warehouseId'].value?.id, value);
                }
            }
          } else {
            const totalQty = this.selectedProductForScan?.returnQty;
            for (let i = 0; i < value.qty; i++) {
                if (this.listLength < totalQty) {
                    this.autoGenerateLists.push({ ...value });
                    this.listLength++;
                }
            }
            this.nameLists = this.autoGenerateLists.slice(0, 100);
            this.totalTBRecord = this.listLength;
            this.trackingForm.controls["qty"].setValue(totalQty - this.listLength);
          }
        }
        const controlNames = Object.keys(this.trackingForm.controls);
        for (let ctrl of controlNames) {
            if (this.trackingOptions?.find((el) => (el.field === ctrl))?.clearField) {
                this.trackingForm.controls[`${ctrl}`].setValue("");
            }
        }
    }

    checkSerialsForSystem(serialNo, productIds, warehouseId, value) {
        this.salesOrderService.checkSerialNoInAllSystem(serialNo, warehouseId, productIds, this.customerReturnDetails?.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
            if (!this.serialConfig?.childInventorySettings[0]?.enabled) {
                if (res.allowSave) {
                    value.systemPresent = false;
                    value.checked = true;
                    this.autoGenerateLists.push(value);
                    this.nameLists = this.autoGenerateLists.slice(0, 100);
                    this.listLength = this.listLength + 1;
                    this.totalTBRecord = this.listLength;
                } else if (!res.allowSave || !res.isMatched) {
                    this.messageService.add({ severity: "error", summary: "Error", detail: `${res.message}` });
                } else {
                    this.messageService.add({ severity: "error", summary: "Error", detail: "SerialNo you tried to import is not a part of this order and associated with other product,you can't add." });
                }
            } else {
                //auto-remove unmatched while save button
                value.systemPresent = false;
                value.checked = true;
                value.remove = true;
                this.autoGenerateLists.push(value);
                this.nameLists = this.autoGenerateLists.slice(0, 100);
                this.listLength++;
                this.totalTBRecord = this.listLength;
            }
            this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
        });
    }

    setTableCheck() {
        for (let s of this.autoGenerateLists) {
            if (this.allChecked) {
                s.checked = true;
            } else {
                s.checked = false;
            }
        }
    }

    setMainHeaderTracking() {
        const checked = this.nameLists.filter((ch) => ch.checked == true);
        if (checked.length == this.nameLists?.length) {
            this.allChecked = true;
        } else {
            this.allChecked = false;
        }
    }

    removeNumber(i) {
        this.nameLists.splice(i, 1);
        this.autoGenerateLists.splice(i, 1);
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength--;
        this.totalTBRecord = this.listLength;
        this.unMatchedSerials = this.autoGenerateLists?.filter(sr => !sr.systemPresent);
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(
                event.first,
                event.first + event.rows
            );
        }
    }

    saveSerializedNo(c) {
        if (this.serialConfig?.childInventorySettings[0]?.enabled && this.unMatchedSerials?.length > 0) {
            const arrayList = JSON.parse(JSON.stringify(this.autoGenerateLists));
            for (let serial of arrayList) {
                if (!serial.systemPresent) {
                    const index = this.autoGenerateLists?.indexOf(serial);
                    this.autoGenerateLists.splice(index, 1);
                }
            }
        }
        // bundle items
        if (this.selectedBundleForScan && this.selectedBundleForScan.typeId && this.selectedBundleForScan.typeId == 4) {
            this.selectedProductListTable?.forEach((element) => {
                if (element.id == this.selectedBundleForScan.id) {
                    element.rmaBundleDetails?.forEach((b) => {
                        if (this.type == DialogType.CREATE) {
                            if (b.id == this.selectedProductForScan.id) {
                                b.rmaBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        RMABundleDetailId: this.selectedProductForScan.id,
                                        RMAProductId: this.selectedBundleForScan.id,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        systemPresent: nl.systemPresent,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: this.app._saveDateTimeWithZone(new Date(nl.expiration)),
                                        statusId: 1,
                                        referenceId: this.refId 
                                    };
                                    b.rmaBundleProductSerialDetail.push(obj);
                                });
                            }
                        } else {
                            if (b.id == this.selectedProductForScan.id) {
                                b.rmaBundleProductSerialDetail = [];
                                this.autoGenerateLists.forEach((nl) => {
                                    const obj = {
                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        RMABundleDetailId: this.selectedProductForScan.id,
                                        RMAProductId: this.selectedBundleForScan.id,
                                        barcode: nl.serialNo,
                                        serialNumber2: nl.serialNo2,
                                        serialNumber3: nl.serialNo3,
                                        serialNumber4: nl.serialNo4,
                                        serialNumber5: nl.serialNo5,
                                        serialNumber6: nl.serialNo6,
                                        serialNumber7: nl.serialNo7,
                                        serialNumber8: nl.serialNo8,
                                        serialNumber9: nl.serialNo9,
                                        serialNumber10: nl.serialNo10,
                                        serialNumber11: nl.serialNo11,
                                        serialNumber12: nl.serialNo12,
                                        serialNumber13: nl.serialNo13,
                                        serialNumber14: nl.serialNo14,
                                        serialNumber15: nl.serialNo15,
                                        serialNumber16: nl.serialNo16,
                                        serialNumber17: nl.serialNo17,
                                        systemPresent: nl.systemPresent,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: this.app._saveDateTimeWithZone(new Date(nl.expiration)),
                                        statusId: 1,
                                        referenceId: this.refId 
                                    };
                                    b.rmaBundleProductSerialDetail.push(obj);
                                });
                            }
                        }
                    });
                }
            });
        } else {
            this.selectedProductListTable?.forEach((element) => {
                if (element.id == this.selectedProductForScan.id) {
                    element.rmaProductSerialDetails = [];
                    this.autoGenerateLists.forEach((nl) => {
                        const obj = {
                            id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            customerRMAId: (this.type == DialogType.EDIT ? this.customerReturnDetails?.id : 0),
                            RMAProductId: this.selectedProductForScan.id,
                            barcode: nl.serialNo,
                            serialNumber2: nl.serialNo2,
                            serialNumber3: nl.serialNo3,
                            serialNumber4: nl.serialNo4,
                            serialNumber5: nl.serialNo5,
                            serialNumber6: nl.serialNo6,
                            serialNumber7: nl.serialNo7,
                            serialNumber8: nl.serialNo8,
                            serialNumber9: nl.serialNo9,
                            serialNumber10: nl.serialNo10,
                            serialNumber11: nl.serialNo11,
                            serialNumber12: nl.serialNo12,
                            serialNumber13: nl.serialNo13,
                            serialNumber14: nl.serialNo14,
                            serialNumber15: nl.serialNo15,
                            serialNumber16: nl.serialNo16,
                            serialNumber17: nl.serialNo17,
                            lotNumber: nl.lotNo,
                            systemPresent: nl.systemPresent,
                            revisionNumber: nl.revisionNo,
                            expirationDate: this.app._saveDateTimeWithZone(new Date(nl.expiration)),
                            statusId: 1,
                            referenceId: this.refId 
                        };
                        element.rmaProductSerialDetails.push(obj);
                    });
                }
            });
        }
        this.selectedProductForScan = null;
        this.selectedBundleForScan = null;
        this.displayScanInfo = false;
    }

    //Import
    openImport() {
        this.displayImport = true;
    }
    hideImport() {
        this.displayImport = false;
    }


    importSerialData(data) {
        this.unMatchedSerials = [];
        for (let dt of data.list) {
            if (dt.serialNo) {
                const present = this.systemTrackingData?.find((depOb) => depOb.serialNo == dt.serialNo);
                if (present) {
                    dt.systemPresent = true;
                    dt.remove = false;
                    dt.checked = false;
                } else if (!present && this.serialConfig?.enabled) {
                    dt.systemPresent = false;
                    dt.remove = false;
                    dt.checked = true;
                } else if (!present || !this.serialConfig?.enabled) {
                    dt.systemPresent = true;
                    dt.checked = false;
                }
            } else {
                dt.systemPresent = true;
                dt.remove = false;
                dt.checked = false;
            }
            //this.autoGenerateLists.push(dt); /*new logic*/
            if (data.action == "add") {
                const index = this.autoGenerateLists?.findIndex((exp) => exp.serialNo == dt.serialNo);
                if (index > -1) {
                    dt.id = this.autoGenerateLists[index].id;
                    this.autoGenerateLists[index] = dt;
                } else {
                    if (this.listLength < this.selectedProductForScan?.returnQty) {
                        this.autoGenerateLists.push(dt);
                        this.listLength++;
                    }
                }
            } else {
                // Get the total quantity from the form control
                const totalQty = this.selectedProductForScan.returnQty || 0;
                const filteredList = data.list.slice(0, totalQty);
                // Fields to skip when comparing
                const skipKeys = ['id', 'expiration', 'field1', 'field2', 'field3', 'field4', 'field5', 'field6', 'field7', 'field8',
                    'field9', 'field10', 'field11', 'field12', 'field13', 'field14', 'field15', 'field16', 'field17', 'field18', 'field19',
                    'field20'
                ];
                // Compare only defined + non-empty fields from newItem against existingItem
                const isMatch = (existingItem: any, newItem: any): boolean => {
                    for (const key in newItem) {
                        if (skipKeys.includes(key)) continue;

                        const newVal = newItem[key];
                        if (newVal !== undefined && newVal !== null && newVal !== '') {
                            if (existingItem[key] !== newVal) return false;
                        }
                    }
                    return true;
                };
                // Step 1: Update existing items
                let updatedList = this.autoGenerateLists.map(existingItem => {
                    const match = filteredList.find(newItem => isMatch(existingItem, newItem));
                    if (match) {
                        return {
                            ...existingItem,
                            ...Object.keys(match).reduce((acc, key) => {
                                acc[key] = match[key] !== undefined && match[key] !== ''
                                    ? match[key]
                                    : existingItem[key]; // preserve existing if new is blank
                                return acc;
                            }, {} as any)
                        };
                    }
                    return existingItem;
                });
                // Step 2: Remove items not found in filteredList
                updatedList = updatedList.filter(existingItem =>
                    filteredList.some(newItem => isMatch(existingItem, newItem))
                );
                // Step 3: Add new items not present in updatedList
                filteredList.forEach(newItem => {
                    const exists = updatedList.some(existingItem => isMatch(existingItem, newItem));
                    if (!exists) {
                        updatedList.push(newItem);
                    }
                });
                this.autoGenerateLists = updatedList;
            }
            this.unMatchedSerials = this.autoGenerateLists?.filter((sr) => !sr.systemPresent);
        }
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.listLength = this.autoGenerateLists.length;
        this.totalTBRecord = this.listLength;
        this.disabledSave = false;
        this.displayImport = false;
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan.returnQty - this.listLength)
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Import successfully, removed duplicate Serial No.",
        });
    }


    importSave(data) {
        this.refId = data.referenceId;
        //duplicate file import
        const unique =
            data.list?.filter((obj) => {
                const autoIndex = this.autoGenerateLists.findIndex((item) => item.serialNo === obj.serialNo);
                const hasBlankSerialNo = this.autoGenerateLists.some((item) => item.serialNo === "");
                return autoIndex === -1 || hasBlankSerialNo;
            }) || [];

        const qty = this.selectedProductForScan?.returnQty - this.listLength;
        if (unique.length > 0 && data.list?.length - unique.length > qty) {
            this.confirmationService.confirm({
                message: "You cannot import serial numbers more than ordered qty,Do you still want to proceed?",
                header: "Alert Confirmation",
                icon: "pi pi-info-circle",
                accept: () => {
                    this.importSerialData(data);
                },
                reject: () => {},
            });
        } else {
            this.importSerialData(data);
        }
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    isBaseCurrency(): boolean {
        return this.baseCurrency?.currencyId == this.accountInfo?.currencyId;
    }
//open tracking list
  openTracking() {
    this.displayTracking = true;
  }

  closeTracking() {
    this.displayTracking = false;
  }
    deleteAll() {
        this.autoGenerateLists = [];
        this.nameLists = [];
        this.unMatchedSerials = [];
        this.listLength = 0;
        this.totalTBRecord = 0;
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
      }
    saveTracking(data) {
        // Create a new object by adding the three fields
        for (let dt of data) {
          const newValue = {
            ...dt,  
            id: 0 ,        // Spread the existing data properties
            systemPresent: true, // Add systemPresent field
            remove: false,       // Add remove field
            checked: false       // Add checked field
          };
            const presentSerialNo = this.autoGenerateLists?.find(nos => nos.serialNo == dt.serialNo);
            if (!presentSerialNo && this.listLength < this.selectedProductForScan?.returnQty) {
            this.autoGenerateLists.push(newValue);
            this.listLength = this.listLength + 1;
          }
        }
        this.trackingForm.controls['qty'].setValue(this.selectedProductForScan?.returnQty - this.listLength);
        this.nameLists = this.autoGenerateLists?.slice(0, 100);
        this.totalTBRecord = this.listLength;
        this.displayTracking = false;
      }

      // posting period
      onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
      }
}
